import { FC, useState } from 'react'
import { format } from 'date-fns'
import SmsFailedIcon from '@mui/icons-material/SmsFailed'

import { Box, Tooltip, Typography } from '@mui/material'
import { RichTextEditorDisplay } from '../RichTextEditor/RichTextEditorDisplay'
interface EmailMessageDisplayProps {
  content: string
  snippet: string
  to_address: string[]
  from_address: string
  send_at: string
  status: string
  attachments: {
    fileName: string
    attachmentId: string
    presignedUrl: string | null
    status: string
    error: null | string
  }[]
}

export const EmailMessageDisplay: FC<EmailMessageDisplayProps> = props => {
  const messageDate = format(new Date(props.send_at), 'MMM. d, yyyy h:mm aaa')
  const [isExpanded, setIsExpanded] = useState(false)
  const succeededAttachment = props.attachments.filter(
    attachment => attachment?.status === 'SUCCESS' && !!attachment?.presignedUrl,
  )
  const failedAttachment = props.attachments.filter(
    attachment => attachment?.status !== 'SUCCESS' || !attachment?.presignedUrl,
  )
  return (
    <Box
      onClick={() => setIsExpanded(!isExpanded)}
      sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, my: 2, px: 4 }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          flexGrow: 1,
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            fontSize: 13,
            fontWeight: 'bold',
          }}
        >
          {props.from_address}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            justifyItems: 'end',
          }}
        >
          <Typography sx={{ fontSize: 12 }}>{messageDate}</Typography>
        </Box>
        {props.status === 'FAILED' && (
          <Tooltip title={props.status}>
            <SmsFailedIcon color="error" />
          </Tooltip>
        )}
      </Box>
      <RichTextEditorDisplay
        content={isExpanded ? props.content : props.snippet ? props.snippet : props.content}
        maxLength={isExpanded ? undefined : 80}
      />
      <Box sx={{ display: 'flex', flex: 1, flexDirection: 'row', flexWrap: 'wrap' }}>
        {succeededAttachment.map(
          (attachment, index) =>
            attachment?.presignedUrl && (
              <Box
                key={index}
                sx={theme => ({
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  borderWidth: '1px',
                  borderColor: theme.palette.grey[200],
                  borderStyle: 'solid',
                  borderRadius: '20px',
                  marginBottom: '10px',
                  paddingY: '5px',
                  paddingX: '10px',
                  textDecoration: 'none',
                })}
              >
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={attachment?.presignedUrl}
                  key={index}
                  style={{ color: '#0077DC', textDecoration: 'none' }}
                >
                  {attachment.fileName}
                </a>
              </Box>
            ),
        )}
      </Box>
      {failedAttachment.length > 0 && (
        <Box
          sx={theme => ({
            display: 'flex',
            flexDirection: 'column',
            borderWidth: '1px',
            borderColor: theme.palette.error.dark,
            borderStyle: 'solid',
            borderRadius: '10px',
            marginBottom: '10px',
            paddingY: '15px',
            paddingX: '5px',
          })}
        >
          {failedAttachment.map((attachment, index) => (
            <Box
              key={index}
              sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', mx: 3 }}
            >
              <Box
                key={index}
                sx={theme => ({
                  display: 'flex',
                  flexDirection: 'row',
                  width: '5px',
                  height: '5px',
                  borderColor: theme.palette.error.dark,
                  backgroundColor: theme.palette.error.dark,
                  borderRadius: '5px',
                  justifyContent: 'space-between',
                  marginX: '5px',
                })}
              />
              <Typography
                key={index}
                sx={theme => ({ color: theme.palette.error.dark, fontSize: '12px' })}
              >
                {attachment?.error}: {attachment.fileName}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}
